import { type PosthogEventData, type PosthogEventCode } from '@walter/shared/constants/posthog'

// USE POSTHOG ONLY CLIENT SIDE
export const logPosthogEvent = (eventCode: PosthogEventCode, eventData?: PosthogEventData) =>
    window.posthog?.capture(eventCode, eventData)
